// extracted by mini-css-extract-plugin
module.exports = {"button":"AuthForm_button__SAdqO","resetPassword":"AuthForm_resetPassword__FzUg2"};